<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @removeTab="removeTab(item.name)" :minor='5'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import {mapState} from 'vuex'
import UserAdd from '../../../../static/form/UserAdd.vue'
import UserLb from '../assembly/UserLb.vue'
import UserGetMessage from '../assembly/UserGetMessage.vue'
export default {
  components: {
    UserAdd,
    UserLb,
    UserGetMessage
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [{
        title: '用户列表',
        name: '1',
        closable: false,
        ref: 'child',
        content: UserLb
      },
      {
        title: '管理员收短信名额',
        name: '2',
        closable: false,
        ref: 'child',
        content: UserGetMessage
      }],
      addobj: {
        title: '添加后台用户',
        name: '3',
        closable: true,
        content: UserAdd
      }
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.editableTabsValue = nval.activeName
        else
          this.editableTabsValue = this.editableTabsValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/Usergl.vue